module.exports = __webpack_public_path__ + "img/50mg-braftovi.e1b43362.png";